import cx from 'classnames'
import { useState } from 'react'
import { FaUndo } from 'react-icons/fa'

const RegInProgress = ({
  kitId,
  regSessionAge,
  onContinue,
  onRestart,
}: {
  kitId: string
  regSessionAge: string
  onContinue: () => Promise<void>
  onRestart: () => void
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const onSubmit = async () => {
    try {
      setIsSubmitting(true)
      await onContinue()
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div>
      <h1 className="title is-spaced has-text-midnightBlue">
        Kit <span className="is-family-monospace has-text-weight-light">{kitId}</span> - Registration Already Started
      </h1>

      <p>
        There is a registration in progress for this kit that was started {regSessionAge}. QR codes are specific to an
        individual kit, so you may be seeing this message because someone else (e.g. in your household) scanned the same
        QR code as you. You may also see this if you started registering this kit on a different device or browser tab
        but did not complete the process.
      </p>

      <p className="mt-4">
        Please check that the kit you're trying to register has the ID{' '}
        <span className="is-family-monospace has-text-primary">{kitId}</span>. If so, click the 'Yes' button to proceed.
        If not, click 'Start over' to input the correct kit ID.
      </p>

      <p className="mt-4">
        If someone else used the same QR code but has a different kit ID, they will need to start over.
      </p>

      <div className="mt-4 has-text-right">
        <div>
          <button
            className={cx('button is-midnightBlue', {
              'is-loading': isSubmitting,
            })}
            disabled={isSubmitting}
            onClick={onSubmit}
          >
            <strong>Yes</strong>&nbsp;- I am registering kit {kitId}
          </button>
        </div>
      </div>

      <hr />

      <p className="mt-3">
        <button className="button is-text pl-0 is-size-7" onClick={onRestart}>
          <div className="is-flex is-align-items-center">
            <FaUndo className="mr-2" /> Start over with another kit ID
          </div>
        </button>
      </p>
    </div>
  )
}

export default RegInProgress
